module.exports = __webpack_public_path__ + "img/foundationIllustrationContextualVayuApplicationFail@3x.d017dd89.png";